'use client'

import { pxToRem } from '@ui/style/muiTheme'
import { Box } from '@mui/joy'

interface BannerLayoutProps {
	children: React.ReactNode
	status: 'progress' | 'complete'
	viewPoint: string
}

const BannerLayout = ({ children, status, viewPoint }: BannerLayoutProps) => {
	return (
		<Box
			sx={{
				height: {
					xs: viewPoint === 'article' ? pxToRem(268) : pxToRem(393),
					md: pxToRem(304),
					lg: pxToRem(360),
					xl: pxToRem(410),
				},
				backgroundImage: {
					xs: 'url(/images/election/banner/election_banner_vote_bg_mo.jpg)',
					md: 'url(/images/election/banner/election_banner_vote_bg_pc.jpg)',
				},
				backgroundSize: {
					xs: viewPoint === 'article' ? pxToRem(900) : 'cover',
					md: '1430px',
					lg: '1920px',
				},
				backgroundPosition: {
					xs: viewPoint === 'article' ? 'center top' : 'center',
					md: 'center 0',
				},
				backgroundRepeat: 'no-repeat',
				backgroundColor: '#F3FFF9',
				position: 'relative',
				overflow: 'hidden',
			}}
		>
			<Box
				maxWidth={
					status === 'complete'
						? '100%'
						: {
								xs: '100%',
								md: pxToRem(720),
								lg: pxToRem(928),
								xl: pxToRem(1216),
						  }
				}
				margin="0 auto"
				sx={{
					height: status === 'complete' ? '100%' : 'auto',
					boxSizing: 'border-box',
					padding:
						status === 'complete'
							? 0
							: {
									xs: `${pxToRem(20)} 0 ${pxToRem(21)} 0`,
									md: `${pxToRem(24)} 0 ${pxToRem(25)} 0`,
									xl: `${pxToRem(32)} 0 ${pxToRem(33)} 0`,
							  },
				}}
			>
				{children}
			</Box>
		</Box>
	)
}

export default BannerLayout
